var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 24C46 18 58 18 66 24",
    stroke: "#FAC1B5",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20L66 24L62 27",
    stroke: "#FAC1B5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#C75E5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 52,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F9907B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 52,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F9907B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 46,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F9907B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 46,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F9907B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 60,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#C75E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalRotation);
export default __webpack_public_path__ + "static/media/MentalRotation.866c16446bc1651e0563aa6cb06dc375.svg";
export { ForwardRef as ReactComponent };